import { BaseContainerModel } from "../base-container.model";
import { bl_fi_mst_item_entity_pricing_link_RowClass } from "../../dbschema/bl_fi_mst_item_entity_pricing_link.model";

export class ItemEntityPricingContainerModel extends BaseContainerModel {
    bl_fi_mst_item_entity_pricing_link: bl_fi_mst_item_entity_pricing_link_RowClass = new bl_fi_mst_item_entity_pricing_link_RowClass();
}